import { render, staticRenderFns } from "./commonPhrasesList.vue?vue&type=template&id=273198ae&"
import script from "./commonPhrasesList.vue?vue&type=script&lang=js&"
export * from "./commonPhrasesList.vue?vue&type=script&lang=js&"
import style0 from "./commonPhrasesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports